// removed by extract-text-webpack-plugin
module.exports = {"HeaderLayout":"_3oiFh6s3"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/header/header-layout.styles.scss
// module id = 534
// module chunks = 0